import TagConfig from "./TagConfig";
import AuthService from "../auth/AuthService"
export default class UserService {
  /******* Tags **********/
  static getTags(app) {  
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = TagConfig.endpointTags;
        let response = await TagConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        console.log("getTags", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  static saveTag(app, tag) {  
    return new Promise(async (resolve, reject) => {
      try{
        console.log("SERVICE SAVE TAG", tag)
        let token = await AuthService.getToken()
        let endpoint = TagConfig.endpointSaveTag;
        console.log("ENDPOINT SAVE tag", endpoint)
        let response = await TagConfig.APIConnector.post(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(tag)
        });
        console.log("saveTag", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  static deleteTagFromUser(app, tag, user){
    return new Promise(async (resolve, reject) => {
      try{
        console.log("SERVICE DELETE TAG FROM USER", tag, user)
        let token = await AuthService.getToken()
        let endpoint = TagConfig.endpointDeleteTagFromUser;
        console.log("ENDPOINT DELETE TAG FROM USER", endpoint)
        let response = await TagConfig.APIConnector.delete(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify({tag:tag, user:user})
        });
        console.log("deleteTagFromUser", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  static deleteTag(app, tag) {  
    return new Promise(async (resolve, reject) => {
      try{
        console.log("SERVICE DELETE TAG", tag)
        let token = await AuthService.getToken()
        let endpoint = TagConfig.endpointDeleteTag;
        console.log("ENDPOINT DELETE TAG", endpoint)
        let response = await TagConfig.APIConnector.delete(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
            body: JSON.stringify(tag)
        });
        console.log("deleteTag", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }

  
  /******** FIN Tags *********/

}


// WEBPACK FOOTER //
// ./src/provider/tag/TagService.js